import { render } from "./AddressTable.vue?vue&type=template&id=0afec824&scoped=true"
import script from "./AddressTable.vue?vue&type=script&lang=js"
export * from "./AddressTable.vue?vue&type=script&lang=js"

import "./AddressTable.vue?vue&type=style&index=0&id=0afec824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afec824"]])

export default __exports__